import { useState } from "react";
import AddCustomLiftHardwareModal from "../ui/AddCustomLiftStyle";
import SplitOrderModal from "./SplitOrderModal";
import { Menu, MenuItem, IconButton } from "@mui/material";
import ScissorsIcon from "@mui/icons-material/ContentCut";

const TableInputs = ({
  order,
  setOrder,
  handleInputChange,
  addRow,
  deleteRow,
  onFocus,
  inputRefs,
  isReadOnly,
  settingsData,
  headrailConfig,
  handleRecalculate,
  LiftStyle,
  Motor,
  recalculateMultipleRows,
}) => {
  const additionalColumns = headrailConfig?.formulas || [];
  const [showCustomLiftStyleModal, setShowCustomLiftStyleModal] =
    useState(false);
  const [showSplitModal, setShowSplitModal] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [splitOption, setSplitOption] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [dropdownRowIndex, setDropdownRowIndex] = useState(null);

  const handleSplitClick = (event, index) => {
    setAnchorEl(event.currentTarget);
    setDropdownRowIndex(index);
    setSelectedRowIndex(index);
  };

  const handleSplitOptionSelect = (option) => {
    setSplitOption(option);
    setAnchorEl(null);
    setDropdownRowIndex(null);
    setShowSplitModal(true);
  };

  const handleDropdownClose = () => {
    setAnchorEl(null);
    setDropdownRowIndex(null);
  };

  const handleSplitComplete = (rowIndex, splitOption) => {
    setSelectedRowIndex((prevIndex) => {
      if (prevIndex !== null && prevIndex > rowIndex) {
        return prevIndex + (splitOption - 1);
      }
      return prevIndex;
    });
  };

  const actionColumnStyle = {
    width: "50px",
    maxWidth: "50px",
    minWidth: "50px",
  };

  return (
    <tbody
      className="table-bg-custom text-dark"
      style={{ backgroundColor: "white" }}
    >
      {order.map((row, index) => (
        <tr key={index} className="table-row-custom">
          <td
            className="p-1 border table-border-custom"
            style={{ width: "50px" }}
          >
            <p
              className="form-control border-light text-dark table-input-custom"
              style={{ width: "50px", color: "black" }}
            >
              {index + 1}
            </p>
          </td>
          <td
            className="p-1 border table-border-custom"
            style={{ width: "100px" }}
          >
            <input
              name="width"
              type="text"
              className="form-control border-dark text-dark table-input-custom"
              style={{ width: "100%", color: "black" }}
              value={row.width || ""}
              onChange={(e) =>
                handleInputChange(index, "width", e.target.value)
              }
              onBlur={() => handleRecalculate && handleRecalculate(index)}
              onFocus={() => onFocus(index, "width")}
              ref={(el) =>
                (inputRefs.current[index] = {
                  ...inputRefs.current[index],
                  width: el,
                })
              }
              readOnly={isReadOnly}
            />
          </td>
          <td
            className="p-1 border table-border-custom"
            style={{ width: "100px" }}
          >
            <input
              name="height"
              type="text"
              className="form-control border-dark text-dark table-input-custom"
              style={{ width: "100%", color: "black" }}
              value={row.height || ""}
              onChange={(e) =>
                handleInputChange(index, "height", e.target.value)
              }
              onBlur={() => handleRecalculate && handleRecalculate(index)}
              onFocus={() => onFocus(index, "height")}
              ref={(el) =>
                (inputRefs.current[index] = {
                  ...inputRefs.current[index],
                  height: el,
                })
              }
              readOnly={isReadOnly}
            />
          </td>
          <td className="p-1 border table-border-custom">
            {row.width && row.height && (
              <select
                name="liftStyle"
                className="form-control border-dark text-dark table-input-custom"
                value={row.liftStyle || ""}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  handleInputChange(index, "liftStyle", selectedValue);
                  if (selectedValue === "custom") {
                    setShowCustomLiftStyleModal(true);
                  }
                }}
                style={{ width: "100%", color: "black" }}
              >
                <option value="">---Select Lift Style---</option>
                {LiftStyle.map((style) => (
                  <option key={style.id} value={style.id}>
                    {style.name}
                  </option>
                ))}
                <option value="">---Select Lift Motor---</option>
                {Motor.map((style) => (
                  <option key={style.id} value={style.id}>
                    {style.name}
                  </option>
                ))}
                <option value="custom">Custom Lift Style</option>
              </select>
            )}
          </td>
          {settingsData?.showLocation && (
            <td className="p-1 border table-border-custom">
              <input
                type="text"
                className="form-control border-dark text-dark table-input-custom"
                value={row?.location || ""}
                style={{ width: "100%", color: "black" }}
                onChange={(e) =>
                  handleInputChange(index, "location", e.target.value)
                }
              />
            </td>
          )}
          {settingsData?.showRemark && (
            <td className="p-1 border table-border-custom">
              <input
                type="text"
                className="form-control border-dark text-dark table-input-custom"
                value={row.remark || ""}
                style={{ width: "100%", color: "black" }}
                onChange={(e) =>
                  handleInputChange(index, "remark", e.target.value)
                }
              />
            </td>
          )}
          {settingsData?.showControl && (
            <td className="p-1 border table-border-custom">
              <input
                type="text"
                className="form-control border-dark text-dark table-input-custom"
                value={row.control || ""}
                style={{ width: "100%", color: "black" }}
                onChange={(e) =>
                  handleInputChange(index, "control", e.target.value)
                }
              />
            </td>
          )}
          {settingsData?.showMountLift && (
            <td className="p-1 border table-border-custom">
              <input
                type="text"
                className="form-control border-dark text-dark table-input-custom"
                value={row.lift || ""}
                style={{ width: "100%", color: "black" }}
                onChange={(e) =>
                  handleInputChange(index, "lift", e.target.value)
                }
              />
            </td>
          )}
          {settingsData?.showTile && (
            <td className="p-1 border table-border-custom">
              <input
                type="text"
                className="form-control border-dark text-dark table-input-custom"
                value={row.tile || ""}
                style={{ width: "100%", color: "black" }}
                onChange={(e) =>
                  handleInputChange(index, "tile", e.target.value)
                }
              />
            </td>
          )}
          {additionalColumns.map((column) => (
            <td className="p-1 border table-border-custom" key={column.key}>
              <input
                type="text"
                className="form-control border-dark text-dark table-input-custom"
                value={row[column.key] || ""}
                style={{ width: "100%", color: "black" }}
                disabled
              />
            </td>
          ))}
          <td className="p-1 border table-border-custom">
            {row.factor != null ? (
              <input
                type="text"
                className="form-control border-dark text-dark table-input-custom"
                style={{ width: "100%", color: "black" }}
                value={row.factor}
                disabled
              />
            ) : (
              <input
                type="text"
                className="form-control border-dark text-dark table-input-custom"
                style={{ width: "100%", color: "#999" }}
                value="—"
                disabled
              />
            )}
          </td>

          <td
            className="p-1 border table-border-custom"
            style={actionColumnStyle}
          >
            <button
              type="button"
              className="btn btn-success"
              style={{ width: "40px", height: "38px", padding: "6px" }}
              onClick={() => addRow(index)}
            >
              <i className="bi bi-plus-circle fs-6 text-white"></i>
            </button>
          </td>

          <td
            className="p-1 border table-border-custom"
            style={actionColumnStyle}
          >
            <IconButton
              onClick={(e) => handleSplitClick(e, index)}
              sx={{
                backgroundColor: "#ffc107",
                color: "white",
                width: "40px",
                height: "38px",
                padding: "6px",
                "&:hover": {
                  backgroundColor: "#e0a800",
                },
              }}
            >
              <ScissorsIcon sx={{ fontSize: "1.2rem", color: "white" }} />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={dropdownRowIndex === index}
              onClose={handleDropdownClose}
              PaperProps={{
                sx: {
                  minWidth: "120px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  backgroundColor: "white",
                  color: "black",
                },
              }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <MenuItem
                onClick={() => handleSplitOptionSelect(2)}
                sx={{ color: "black" }}
              >
                Split into 2
              </MenuItem>
              <MenuItem
                onClick={() => handleSplitOptionSelect(3)}
                sx={{ color: "black" }}
              >
                Split into 3
              </MenuItem>
            </Menu>
          </td>

          <td
            className="p-1 border table-border-custom"
            style={actionColumnStyle}
          >
            {index !== 0 ? (
              <button
                type="button"
                className="btn btn-danger"
                style={{ width: "40px", height: "38px", padding: "6px" }}
                onClick={() => deleteRow(index)}
              >
                <i className="bi bi-trash fs-6 text-white"></i>
              </button>
            ) : (
              <div style={{ width: "40px", height: "38px" }}></div>
            )}
          </td>
        </tr>
      ))}

      <AddCustomLiftHardwareModal
        show={showCustomLiftStyleModal}
        handleClose={() => setShowCustomLiftStyleModal(false)}
      />
      <SplitOrderModal
        show={showSplitModal}
        handleClose={() => setShowSplitModal(false)}
        splitOption={splitOption}
        rowIndex={selectedRowIndex}
        order={order}
        setOrder={setOrder}
        handleInputChange={handleInputChange}
        recalculateMultipleRows={recalculateMultipleRows}
        onSplitComplete={handleSplitComplete}
      />
    </tbody>
  );
};

export default TableInputs;
